// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608180204/js/" + chunkId + "." + {"44":"3a130049","225":"bdc49e0b","481":"1ee82dbd","486":"472ee364","770":"4c53e519"}[chunkId] + ".0.17550901880969827.chunk.js";
};